import { computed, inject, Injectable } from '@angular/core';
import { Provider } from '@common/enums';
import { ProductMode } from '@common/models';
import { AbilityService } from '@common/services/auth/ability.service';
import { AuthStateService } from '@common/services/auth/auth-state.service';
import { getPrefix } from '@common/utils';

@Injectable({ providedIn: 'root' })
export class AuthContextService {
  private readonly ability = inject(AbilityService);
  private readonly authState = inject(AuthStateService);

  public readonly domainId = computed<string>(() => this.authState.authUser()?.DomainId);
  public readonly domainName = computed<string>(() => this.authState.authUser()?.DomainName);
  public readonly email = computed<string>(() => this.authState.authUser()?.Email);
  public readonly id = computed<string>(() => this.authState.authUser()?.Id);
  public readonly inBackup = computed<boolean>(() => this.authState.authUser()?.InBackup);
  public readonly name = computed<string>(() => this.authState.authUser()?.Name);
  public readonly productMode = computed<ProductMode>(() => this.authState.systemInfo()?.ProductMode);
  public readonly provider = computed<Provider>(() => this.authState.authUser()?.Provider);
  public readonly userProviderState = computed<string>(() => this.authState.authUser()?.UserProviderState);

  public readonly prefix = computed<string>(() => getPrefix(this.provider(), this.ability.isAlternateSignIn()));
}
